import React from 'react';
import BaseScadaNode from './BaseScadaNode';
import axiosInstance from '../../AxiosInstance';

export default function CustomMachineNode(props) {
    const { data } = props;
    const detail = data?.machine_type_detail;
    if (!detail) return (
        <BaseScadaNode {...props}>
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#475569', fontSize: 11, border: '1px dashed #334155', borderRadius: 4 }}>
                No machine type
            </div>
        </BaseScadaNode>
    );

    const v = parseFloat(data?.liveValue);
    const currentState = detail.states_config?.find(s => String(s.value) === String(Math.round(isNaN(v) ? -999 : v)));
    const borderColor = currentState?.color || '#475569';

    const handleAction = (action) => {
        if (action.confirm_required) {
            if (!window.confirm(`Execute: ${action.label}?`)) return;
        }
        if (!data?.variable_data_detail?.device_id) return;
        // POST to device_action_button/publish/ endpoint (reuses existing endpoint)
        axiosInstance.post('device_action_button/', {
            device_id: data.variable_data_detail.device_id,
            variable_id: data.variable_data_detail.variable_id,
            value: action.publish_value,
        }).catch(() => {});
    };

    return (
        <BaseScadaNode {...props}>
            <div style={{ width: '100%', height: '100%', border: `3px solid ${borderColor}`, borderRadius: 8, overflow: 'hidden', background: '#1E293B', display: 'flex', flexDirection: 'column' }}>
                {/* Machine image */}
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: 4 }}>
                    {detail.image_url
                        ? <img src={detail.image_url} alt={detail.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                        : <div style={{ color: '#475569', fontSize: 11, textAlign: 'center' }}>{detail.name}</div>
                    }
                </div>
                {/* State badge */}
                <div style={{ background: borderColor, padding: '2px 6px', textAlign: 'center', fontSize: 10, color: '#fff', fontWeight: 600, flexShrink: 0 }}>
                    {currentState?.label || (isNaN(v) ? '---' : String(v))}
                </div>
                {/* Action buttons (view mode only) */}
                {!data?.isEditMode && detail.actions_config?.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2, padding: 3, flexShrink: 0 }}>
                        {detail.actions_config.map((action, i) => (
                            <button
                                key={i}
                                onClick={(e) => { e.stopPropagation(); handleAction(action); }}
                                style={{
                                    flex: 1, minWidth: 0, fontSize: 9, padding: '2px 4px',
                                    background: '#334155', border: '1px solid #475569',
                                    color: '#E2E8F0', borderRadius: 4, cursor: 'pointer',
                                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                                }}
                            >
                                {action.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </BaseScadaNode>
    );
}
